module.exports = __webpack_public_path__ + "static/img/otp_img2.7dadb79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/otp_img2.png
// module id = midc
// module chunks = 7